import { Row, Col} from "react-bootstrap";
import { useImages } from '../context/ImageContext';
const { Image } = require("react-bootstrap");

function BlueBank({count})
{
    const { images } = useImages();

    const imageStyle = {
        width: '15px',
        height: '15px',
    }

    const corruptionStyle = {
        color: 'Red',
        backgroundColor: 'rgb(40, 40, 56)',
    }

    const bankStyle = {
        backgroundColor: ' rgb(171, 199, 228)'
    }

    var bankOne = [];
    for (let i=0;i<5;i++){
        bankOne.push(
            <td key={`one ${i}`} style={bankStyle}>
                <Image src={i < count ? images.BlueCube.src : images.MissingCube.src} style={imageStyle}/>
            </td>
        )
    }

    var bankTwo = [];
    for (let i=0;i<5;i++){
        bankTwo.push(
            <td key={`two ${i}`} style={bankStyle}>
                <Image src={i < count-5 ? images.BlueCube.src : images.MissingCube.src} style={imageStyle}/>
            </td>
        )
    }

    var bankThree = [];
    for (let i=0;i<6;i++){
        bankThree.push(
            <td key={`three ${i}`} style={bankStyle}>
                <Image src={i < count-10 ? images.BlueCube.src : images.MissingCube.src} style={imageStyle}/>
            </td>
        )
    }

    if (count > 16){
        for (let i=0;i<count-16;i++){
            bankThree.push(
                <td key={`extra ${i}`} style={bankStyle}>
                    <Image src={images.BlueCube.src} style={imageStyle}/>
                </td>
            )
        }
    }

    const rowStyle = 
    {
        alignItemsCenter: true
    }

    return (
        <table style={{width: '100%'}}>
            <tbody>
                <tr>
                    <td style={corruptionStyle}>
                        -6
                        <img src={images.Resource.src} style={imageStyle}/>
                    </td>
                    {bankOne}
                    <td style={corruptionStyle}>
                        -4
                        <img src={images.Resource.src} style={imageStyle}/>
                    </td>
                    {bankTwo}
                    <td style={corruptionStyle}>
                        -2
                        <img src={images.Resource.src} style={imageStyle}/>
                    </td>
                    {bankThree}
                    <td style={corruptionStyle}>
                        -0
                        <img src={images.Resource.src} style={imageStyle}/>
                    </td>
                </tr>
            </tbody>
        </table>
        )
}
export default BlueBank;